package one.healthium.domain.app_visit

import co.touchlab.kermit.Logger
import one.healthium.base.preferences.AppPreferences
import one.healthium.base.utils.daysBetween
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.models.SubscriptionStatus
import kotlin.time.Clock
import kotlin.time.Instant

class AppVisitCounter(
    private val appPreferences: AppPreferences,
    private val userInteractor: UserInteractor
) {
    suspend fun countAppVisit() {
        val lastVisitDate = appPreferences.lastVisitDate?.let { Instant.fromEpochMilliseconds(it) } ?: Clock.System.now()
        val daysBetween = lastVisitDate.daysBetween(Clock.System.now())
        val isPaidUser = userInteractor.getUser().purchases.subscription == SubscriptionStatus.Active
        Logger.d("daysBetween: $daysBetween")
        when (daysBetween) {
            0 -> Unit
            1 -> appPreferences.visitsInRow += 1
            else -> appPreferences.visitsInRow = 0
        }
        appPreferences.lastVisitDate = Clock.System.now().toEpochMilliseconds()
        if (isPaidUser) {
            appPreferences.appVisitCounter += 1
        }

    }

    fun reset() {
        appPreferences.visitsInRow = 0
    }
}